import React from 'react';
import { connect } from 'react-redux';
import classNames from "classnames";
import moment from 'moment';
import { ControlTextE } from 'UI/CustomComponents/Controls';
import { Control, Form, Errors, actions } from 'react-redux-form'
import Select from 'react-select';
// Actions
import {
    resetError,
    FetchUpdateAdminSavingParam,
    fetchSolutionInScopeValues
} from 'actions/spendActions';

// Utils
import { BreakLine } from 'utils/Utils';

class SavingAdminParam extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            adminSavingData: [],
            editedAdminSaving: [],
            responseMessage: '',
            isError: false,
            indirectSolutionScopeOption :[],
            selectedIndirectScope : '',
        };

        this.loadData = this.loadData.bind(this);
        this.fetchAdminSavingParam = this.fetchAdminSavingParam.bind(this);
    }

    componentDidMount() {
        this.loadData();
    }

    handleSolutionInScopeChange(value)
    {
        this.setState({  selectedIndirectScope :  value },()=>{this.fetchAdminSavingParam(value)});
    }

    fetchAdminSavingParam(solutionInScope)
    {
        const request = {
            Read_Write_Flag: "R",
            UserId: this.props.user.user.Email,
            SolutionInScope: solutionInScope,
            Admin_Saving_List: []
        };

        this.props.FetchUpdateAdminSavingParam(request).then((response) => {
            if (response.status === 200 && Array.isArray(response.data.Result)) {
                this.setState({ adminSavingData: response.data.Result, selectedIndirectScope : solutionInScope });
            }
        });
    }

    loadData() {
        var indirectScopeValues=[]; 

        this.props.fetchSolutionInScopeValues().then((response) => {
            if (response.status === 200) {
                
                this.fetchAdminSavingParam(response.data.Result[0].SOLUTION_IN_SCOPE_NAME);
                //---------------------------------------------------------------------
                var indirectScopeValues=[]; 
                
                if (response.data.Result !== null) {
                    response.data.Result.forEach(item => {
                        const value = item.SOLUTION_IN_SCOPE_NAME;
                        const alreadyExists = indirectScopeValues.some(existing => existing.value === value);
                        
                        if (!alreadyExists) {
                            indirectScopeValues.push({ label: value, value: value });
                        }
                    });
                }						

                this.setState({ indirectSolutionScopeOption: indirectScopeValues, selectedIndirectScope : response.data.Result[0].SOLUTION_IN_SCOPE_NAME});
            }
        });
        
    }

    trackChanges = (record) => {
        let updatedRecords = [...this.state.editedAdminSaving];
        let index = updatedRecords.findIndex(x => x.SAVING_PARAM_ID === record.SAVING_PARAM_ID);

        if (index > -1) {
            updatedRecords[index] = record;
        } else {
            updatedRecords.push(record);
        }

        this.setState({
            editedAdminSaving: updatedRecords,
            responseMessage: '',
            isError: false
        });
    }

    onSave = () => {
        this.setState({ isLoading: true, responseMessage: '', isError: false });

        const payload = {
            Read_Write_Flag: "W",
            UserId: this.props.user.user.Email,
            SolutionInScope:this.state.selectedIndirectScope,
            Admin_Saving_List: this.state.editedAdminSaving.map(item => {
                // map VISIBILITY (or FIELD_AVAILABLE) to FIELD_AVAILABLE expected by server
                const visibilityValue = item.VISIBILITY || item.FIELD_AVAILABLE || 'Yes';
                return {
                    ...item,
                    // convert SAVING_PARAM_VALUE to cleaned string (no $ or %)
                    SAVING_PARAM_VALUE: item.SAVING_PARAM_VALUE
                        ? item.SAVING_PARAM_VALUE.toString().replace(/[$%]/g, "")
                        : "",
                    // ensure server-side property is FIELD_AVAILABLE (string "Yes"/"No")
                    FIELD_AVAILABLE: visibilityValue
                };
            })
        };

        this.props.FetchUpdateAdminSavingParam(payload).then((response) => {
            if (response.status === 200 && Array.isArray(response.data.Result)) {
                this.setState({
                    adminSavingData: response.data.Result,
                    editedAdminSaving: [],
                    isLoading: false,
                    responseMessage: this.props.content.successMessage,
                    isError: false
                });
            } else {
                this.setState({
                    isLoading: false,
                    responseMessage: this.props.content.errorMessage,
                    isError: true
                });
            }
        }).catch(() => {
            this.setState({
                isLoading: false,
                responseMessage: this.props.content.errorMessage,
                isError: true
            });
        });
    }

    componentWillUnmount() {
        this.props.resetError();
    }

    render() {
        return (
            <div style={{ width: '100%' }}>
                <div className="grid-x">
                    <div className="medium-12">
                        {/* Loader */}
                        {this.state.isLoading &&
                            <img style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto' }}
                                src="images/ajax-loader.gif" alt="loading" />
                        }

                        {/* Header */}
                        {this.state.adminSavingData.length > 0 &&
                            <div>
                                <div className="grid-x">
                                    <div className="medium-6 float-left" style={{ fontSize: '1.2rem', paddingBottom: '8px' }}>
                                        {BreakLine('Rise Saving Admin Paramaeters')}
                                    </div>
                                    <div className="medium-6" style={{ display: 'flex', justifyContent: 'center' }}>
                                        <div style={{ margin: '0 0 0.5rem', color: this.state.isError ? 'red' : '#4fb81c' }}>
                                            {this.state.responseMessage}
                                        </div>
                                    </div>
                                </div>

                                <div className="grid-x">
                                    <div className="medium-11 float-left" style={{ paddingBottom: '8px' }}>
                                        {`Rise Saving Admin Paramaeters`}
                                    </div>
                                    {this.props.user.userprofile.Roles[0].indexOf("Admin") > -1 &&
                                        <div className="medium-1" style={{ paddingBottom: '2px' }}>
                                            <button
                                                className={classNames('float-right', {
                                                    'hand-cursor': this.state.editedAdminSaving.length > 0,
                                                    'gray-scale': this.state.editedAdminSaving.length === 0
                                                })}
                                                onClick={this.onSave}
                                                disabled={this.state.isLoading || this.state.editedAdminSaving.length === 0}
                                                type="submit"
                                            >
                                                <img width="25" title={this.props.content.save} src="images/save_active.svg" />
                                            </button>
                                        </div>}
                                </div>
                            </div>}
                    </div>
                </div>
                <table style={{border : 'solid',borderWidth : '1px'}}><tr>
                    <td><div>Solution in Scope : </div>
                    </td>
                    <td><div>   <Select
                        className="border-less-DD"
                        model="discovery.IndirectScope"
                        id="discovery.IndirectScope"
                        name="discovery.IndirectScope"
                        placeholder={'Solution In Scope'}
                        value={this.state.indirectSolutionScopeOption.filter(option => option.label === this.state.selectedIndirectScope)}
                        noOptionsMessage={() => null}
                        onChange={(value) => this.handleSolutionInScopeChange(value.label)}
                        options={this.state.indirectSolutionScopeOption}
                        isSearchable={false}
                        disabled={false}
                    />
                    </div></td></tr></table>
                {/* Table */}
                {this.state.adminSavingData.length > 0 &&
                    <div className="grid-x">
                        <div className="medium-12">
                            <Form
                                model="adminSavingParameter"
                            >
                                <div className="grid-x basic-table">
                                    <table>
                                        <thead>
                                            <tr className="eachRow">
                                                <th>Tab Name</th>
                                                <th>Field Name</th>
                                                <th>Value</th>
                                                <th>Table Name</th>
                                                <th>Visibility</th> {/* CHECKBOX NOW */}
                                                <th>Updated By</th>
                                                <th>Updated Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.adminSavingData.map((parameter) => (
                                                <TableRows
                                                    key={parameter.SAVING_PARAM_ID} // stable key
                                                    adminParameter={parameter}
                                                    trackChanges={this.trackChanges}
                                                />
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </Form>
                        </div>
                    </div>}
            </div>
        );
    }
}

class TableRows extends React.Component {
  constructor(props) {
    super(props);

    const { SAVING_PARAM_VALUE } = props.adminParameter || {};
    const { symbol, number } = this.splitValue(SAVING_PARAM_VALUE);

    // Determine initial visibility:
    const rawVis = (props.adminParameter && (props.adminParameter.VISIBILITY !== undefined && props.adminParameter.VISIBILITY !== null))
      ? props.adminParameter.VISIBILITY
      : (props.adminParameter && (props.adminParameter.FIELD_AVAILABLE !== undefined && props.adminParameter.FIELD_AVAILABLE !== null))
        ? props.adminParameter.FIELD_AVAILABLE
        : 'Yes';

    const visibility = (rawVis === 'No' || rawVis === 'N' || rawVis === 'no' || rawVis === 'n') ? 'No' : 'Yes';

    this.state = {
      inputValue: number,   // user-editable numeric part
      symbol: symbol,       // currency/% symbol part
      visibility: visibility
    };
  }

  // Sync local state when parent props change (visibility/value)
  componentDidUpdate(prevProps) {
    // if adminParameter reference changed or core fields changed, update local state
    const prev = prevProps.adminParameter || {};
    const curr = this.props.adminParameter || {};

    const prevVis = (prev.VISIBILITY !== undefined && prev.VISIBILITY !== null) ? prev.VISIBILITY : prev.FIELD_AVAILABLE;
    const currVis = (curr.VISIBILITY !== undefined && curr.VISIBILITY !== null) ? curr.VISIBILITY : curr.FIELD_AVAILABLE;

    const prevVal = prev.SAVING_PARAM_VALUE;
    const currVal = curr.SAVING_PARAM_VALUE;

    // compute normalized forms
    const normPrevVis = (prevVis === 'No' || prevVis === 'N' || prevVis === 'no' || prevVis === 'n') ? 'No' : (prevVis ? 'Yes' : undefined);
    const normCurrVis = (currVis === 'No' || currVis === 'N' || currVis === 'no' || currVis === 'n') ? 'No' : (currVis ? 'Yes' : 'Yes');

    // If visibility changed externally, update state
    if (normPrevVis !== normCurrVis && this.state.visibility !== normCurrVis) {
      this.setState({ visibility: normCurrVis });
    }

    // If value changed externally, update inputValue & symbol
    if (prevVal !== currVal) {
      const { symbol, number } = this.splitValue(currVal);
      // Only set state when different to avoid extra renders
      if (this.state.inputValue !== number || this.state.symbol !== symbol) {
        this.setState({ inputValue: number, symbol: symbol });
      }
    }
  }

  // Utility: split into symbol + number
  splitValue = (val) => {
    if (val === undefined || val === null) return { symbol: "", number: "" };
    const str = String(val);
    // Try to extract number part and non-numeric prefix/suffix
    const match = str.match(/^([^0-9\-\.]*)([0-9\-,\.]*)(.*)$/);
    if (match) {
      const prefix = match[1] || "";
      const numberPart = match[2] || "";
      const suffix = match[3] || "";
      return {
        symbol: (prefix + suffix).trim(),
        number: numberPart.replace(/,/g, "")
      };
    }
    return { symbol: "", number: str };
  };

  handleChange = (e) => {
    let raw = e.target.value.replace(/[^0-9.]/g, ""); // only digits + .
    if (/^\d*\.?\d*$/.test(raw) || raw === "") {
      this.setState({ inputValue: raw });

      const updatedRow = {
        ...this.props.adminParameter,
        SAVING_PARAM_VALUE: raw // raw number only, API will get clean number
      };
      // preserve visibility from current state
      updatedRow.VISIBILITY = this.state.visibility;
      this.props.trackChanges(updatedRow);
    }
  };

  handleBlur = () => {
    const { inputValue, symbol } = this.state;
    this.setState({ inputValue: inputValue, displayValue: inputValue + symbol });
  };

  // checkbox change handler
  handleVisibilityToggle = (e) => {
    const checked = e.target.checked;
    const newVis = checked ? 'Yes' : 'No';
    this.setState({ visibility: newVis });

    const updatedRow = {
      ...this.props.adminParameter,
      SAVING_PARAM_VALUE: this.state.inputValue,
      VISIBILITY: newVis,
      FIELD_AVAILABLE: newVis
    };

    this.props.trackChanges(updatedRow);
  };

  render() {
    const row = this.props.adminParameter || {};
    const { inputValue, symbol, visibility } = this.state;

    return (
      <tr className="eachRow">
        <td>{row.SAVING_TAB_NAME}</td>
        <td>{row.PARAM_FIELD_NAME}</td>
        <td>
          <ControlTextE
            model="SAVING_PARAM_VALUE"
            id={"SAVING_PARAM_VALUE_" + row.SAVING_PARAM_ID}
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            value={inputValue + symbol} // always show with symbol
            type="text"
            className="edit-textarea edit-width"
            readOnly={false}
          />
        </td>
        <td>{row.HEADER_FIELD_NAME}</td>
        {/* Visibility column with checkbox */}
        <td style={{ textAlign: 'center' }}>
          <input
            type="checkbox"
            id={"VISIBILITY_" + row.SAVING_PARAM_ID}
            checked={visibility === 'Yes'}
            onChange={this.handleVisibilityToggle}
          />
        </td>

        <td>{row.USER_ID}</td>
        <td>{row.LOAD_TS ? moment(row.LOAD_TS).format("L") : "-"}</td>
      </tr>
    );
  }
}

const mapStateToProps = (state) => ({
    user: state.default,
    content: state.content.menu.EnablementParametersManager[0].FieldVisibilityTab,
});

const mapDispatchToProps = (dispatch) => ({
    resetError: () => dispatch(resetError()),
    FetchUpdateAdminSavingParam: (data) => dispatch(FetchUpdateAdminSavingParam(data)),
    fetchSolutionInScopeValues: () => dispatch(fetchSolutionInScopeValues()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SavingAdminParam);
